import iRouteLogo from '@/assets/branding/iroute/iroute_logo.svg';

const colors = {
  // Brand colors
  brand_primary: '#EC4A0A',
  brand_primary_hover: '#C4320A', // −10 L, −8 S
  brand_primary_highlight: '#FDDCAB', // +23 L, +7 S
  brand_primary_mid: '#FB6514', // +8 L,  +2 S
  brand_primary_dark: '#7E2410', // −25 L, −3 S
  brand_secondary: '#9C2A10', // hue +4°, −15 L, −13 S
  brand_accent_start: '#EC4A0A',
  brand_accent_end: '#FD853A',
  brand_accent_light_start: '#FFF6ED',
  brand_accent_light_end: '#FFFAF5',
  brand_complementary_accent: 'rgb(21,112,239)',
  brand_auth_gradient_mid: '#9C2A10',
  brand_auth_gradient_end: '#7E2410',
  brand_auth_warp_mid: '#FB6514',
};

export default {
  name: 'iRoute Trucking Academy',
  isSAML: true,
  allowPersonalCourses: false,
  logo: iRouteLogo,
  colors,
};
